import { render, staticRenderFns } from "./item-detail-edito.vue?vue&type=template&id=1baa05af&scoped=true&"
import script from "./item-detail-edito.vue?vue&type=script&lang=js&"
export * from "./item-detail-edito.vue?vue&type=script&lang=js&"
import style0 from "./item-detail-edito.vue?vue&type=style&index=0&id=1baa05af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baa05af",
  null
  
)

export default component.exports